export default __webpack_public_path__ + "static/step3-2df49f2a242205eeafcb67385f6ffe02.png";